import React, { useState, useEffect, useRef } from 'react'
import { Accordion,
    AccordionDetails,
    Typography,
    FormControl,
    FormLabel,
    FormControlLabel,
    RadioGroup,
    Radio
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import 'date-fns'
import { useDispatch, useSelector } from 'react-redux'
import { Alerta } from '../../controls/Alerta'
import { useStyles, StyledAccordionSummary } from './InformacionBasicaStyle'
import { updatePadre } from '../../redux/actions/padreActions'
import { updateInfoBasica } from '../../redux/actions/informacionBasicaActions'

import { isBrowser } from 'react-device-detect';

export const InformacionBasicaScreen = ( ) => {
    const classes = useStyles();
    const [expanded, setexpanded] = useState(true)
    
    const dispatch = useDispatch()
    const informacion_basica = useSelector( state => state.informacion_basica )
    const estudiante = useSelector( state => state.estudiante )

    return (
        <form 
        className={ classes.form }
        autoComplete="off"
        id="frm-padre" >
            <Accordion expanded={ expanded } id="acordion" onChange={ () => { setexpanded( !expanded ) } }>
                <StyledAccordionSummary aria-controls="panel1a-content" id="panel1a-hea"
                expandIcon={ <ExpandMoreIcon className={ classes.iconExpander }/> } >
                    <Typography className={ classes.heading }>
                        Información básica
                    </Typography>
                </StyledAccordionSummary>
                <AccordionDetails className={ classes.detalle }>

                    <div className="ed-grid rows-gap s-gap-3 m-gap-3 l-gap-3 s-grid-2 m-grid-4 lg-grid-12">
                        <div className="s-y-1 s-x-1 s-cols-2 
                                        m-y-1 m-x-1 m-cols-4
                                        l-y-1 l-x-1 l-cols-12">  
                            <div className={ classes.wrapper }>
                                <FormControl component="fieldset">
                                    <FormLabel component="legend">Selecciona tu CARGO/OCUPACIÓN</FormLabel>
                                    <RadioGroup aria-label="cargo" name="cargo" value={informacion_basica.cargo}
                                    onChange={ ( { target } ) => {
                                        dispatch( updateInfoBasica( {miembro: '' } ) )
                                        dispatch( updateInfoBasica( {cargo: !target.value ? '' : target.value } ) )
                                        let cargo_nombre = 'padre/madre de familia';
                                        switch (target.value) {
                                            case '001':
                                                cargo_nombre = 'Director';
                                                break;
                                            case '002':
                                                cargo_nombre = 'Docente';
                                                break;
                                            case '003':
                                                cargo_nombre = 'Padre de Familia';
                                                break;
                                            case '004':
                                                cargo_nombre = 'Personal administrativo';
                                                break;
                                            // case '005':
                                            //     cargo_nombre = 'Especialista DRE/UGEL';
                                            //     break;
                                            // case '006':
                                            //     cargo_nombre = 'Especialista CGR';
                                            //     break;
                                        }
                                        dispatch( updateInfoBasica( {cargo_nombre: cargo_nombre } ) )
                                        dispatch( updatePadre( {tipo_doc_padre: '0101' } ) )
                                    } }
                                    row={isBrowser}>
                                        <FormControlLabel value="001" disabled={ estudiante.tipo_inst_edu != '' } control={<Radio />} label="Director" />
                                        <FormControlLabel value="002" disabled={ estudiante.tipo_inst_edu != '' } control={<Radio />} label="Docente" />
                                        <FormControlLabel value="003" disabled={ estudiante.tipo_inst_edu != '' } control={<Radio />} label="Padre de Familia" />
                                        <FormControlLabel value="004" disabled={ estudiante.tipo_inst_edu != '' } control={<Radio />} label="Personal administrativo" />
                                        {/* 
                                        <FormControlLabel value="005" disabled={ estudiante.tipo_inst_edu != '' } control={<Radio />} label="Especialista DRE/UGEL" />
                                        <FormControlLabel value="006" disabled={ estudiante.tipo_inst_edu != '' } control={<Radio />} label="Especialista CGR" /> 
                                        <FormControlLabel value="007" disabled={ estudiante.tipo_inst_edu != '' } control={<Radio />} label="Estudiante" />
                                        */}
                                    </RadioGroup>
                                </FormControl>
                            </div>
                        </div>
                        <div className="s-y-2 s-x-1 s-cols-2 
                                        m-y-2 m-x-1 m-cols-4
                                        l-y-2 l-x-1 l-cols-12">  
                            <div className={ classes.wrapper }>
                                {
                                    (informacion_basica.cargo === '008' || informacion_basica.cargo === '009')
                                    &&
                                    <FormControl component="fieldset">
                                        <FormLabel component="legend">Selecciona si eres miembro del CONEI, de la Comisión de Mantenimiento u otros</FormLabel>
                                        <RadioGroup aria-label="miembro" name="miembro" value={informacion_basica.miembro}
                                        onChange={ ( { target } ) => {
                                            dispatch( updateInfoBasica( {miembro: !target.value ? '' : target.value } ) )
                                        } }
                                        row={isBrowser}>
                                            <FormControlLabel value="001" disabled={ estudiante.tipo_inst_edu != '' } control={<Radio />} label="CONEI (Consejo Educativo Institucional)" />
                                            <FormControlLabel value="002" disabled={ estudiante.tipo_inst_edu != '' } control={<Radio />} label="COMISIÓN DE MANTENIMIENTO" />
                                            <FormControlLabel value="003" disabled={ estudiante.tipo_inst_edu != '' } control={<Radio />} label="OTROS" />
                                        </RadioGroup>
                                    </FormControl>
                                    }
                            </div>
                        </div>
                    </div>

                </AccordionDetails>
            
            </Accordion>

        </form>
    )
}
